import { render, staticRenderFns } from "./HearingDisplayCourt.vue?vue&type=template&id=3271dcf1"
import script from "./HearingDisplayCourt.vue?vue&type=script&lang=js"
export * from "./HearingDisplayCourt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports